import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider } from 'styled-components/macro'
import { GlobalStyles, theme } from 'theme'
import { ToasterProvider } from 'utils/useToaster'
import { ApolloAuthProviders } from 'utils/ApolloAuthProviders'
import App from './App'

const InternalPortal = () => (
  <ThemeProvider theme={theme}>
    <ToasterProvider>
      <ApolloAuthProviders>
        <Router>
          <GlobalStyles />
          <App />
        </Router>
      </ApolloAuthProviders>
    </ToasterProvider>
  </ThemeProvider>
)

export default InternalPortal
